import { Controller } from 'stimulus';

class NavigationController extends Controller {
  openDropdown(event) {
    event.preventDefault();

    const link = event.currentTarget;
    const { depth } = link.dataset;

    link.classList.add('is-open');
    this.listTarget.setAttribute('data-depth', depth);
  }

  closeDropdown(event) {
    event.preventDefault();

    const currentLink = event.currentTarget;
    const { depth } = currentLink.dataset;

    const list = currentLink.closest('ul');

    const link = list.previousElementSibling;

    link.classList.remove('is-open');
    this.listTarget.setAttribute('data-depth', depth);
  }
}

NavigationController.targets = [
  'list',
];

export default NavigationController;
